import * as LOG from "@/log";
import { debugApi } from "@/log";
import { Get, Post, Delete } from "@/services/Server";
import URL from "@/services/urls";
import { ChatWidgetPublicSettingsData } from "@/TickApi";

export async function getCWSettings(cwToken: string, forceRefresh: boolean): Promise<ChatWidgetPublicSettingsData> {
    if (!cwToken) {
        LOG.error('Error while retrieving chatwidget settings because no cwToken was provided', { cwToken });
        return;
    }

    try {
        const fresh = forceRefresh ? `?timestamp=${new Date().getTime()}` : '';
        if (forceRefresh) {

            debugApi('[Widget:Fetch]getting fresh chatwidget settings');
        } else {
            debugApi('[Widget:Fetch]getting chatwidget settings (cache possibility)');
        }
        const response = await Get<ChatWidgetPublicSettingsData>(URL.getSettings + `/${cwToken}${fresh}`);
        debugApi('[Widget:Fetch]getting chatwidget settings success');
        return response.data;
    } catch (error) {
        LOG.error('Error while retrieving chatwidget settings', { error });
        return null;
    }
}